export default "__VITE_ASSET__xeHzlcC0__"